import { makeStyles } from 'tss-react/mui'

type FlyoutCasProgramSetupStyleParams = {
  showCloudFormationDataFeedsSetup: boolean
}

export const useStyles = makeStyles<FlyoutCasProgramSetupStyleParams>()(
  (theme, { showCloudFormationDataFeedsSetup }) => ({
    heading: {
      color: theme.palette.labraText.primary,
      fontFamily: theme.typography.fontFamily,
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '24px',
      letterSpacing: '0.15px',
    },
    field: {
      width: '459.5px',
      textAlign: 'left',
      marginTop: theme.spacing(1.5),
    },
    fieldTopAligned: {
      marginTop: 0,
    },
    inputsColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
    dataFeedsRevampFooter: {
      height: 'auto',
      marginTop: showCloudFormationDataFeedsSetup ? theme.spacing(2.5) : 0,
    },
    loadingText: {
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0.1px',
      color: theme.palette.labraText.description,
    },
    loadingTextContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
    loader: {
      width: '16px',
      height: '16px',
      flexShrink: 0,
      color: theme.palette.labraText.tertiary,
    },
    check: {
      color: theme.palette.textBackground.dark,
    },
    buttonContainer: {
      marginTop: theme.spacing(0.625),
    },
    fieldsDataFeedsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    subHeadingContainer: {
      width: '100%',
      marginTop: theme.spacing(2),
      color: theme.palette.shadows.light,
    },
    sectionText: {
      fontSize: theme.spacing(1.75),
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: theme.spacing(2.5),
      letterSpacing: '0.25px',
      color: theme.palette.labraText.description,
      fontFamily: theme.typography.fontFamily,
      textAlign: 'left',
      marginBottom: theme.spacing(2),
    },
    validateConnectionButton: {
      width: theme.spacing(24.125),
      height: theme.spacing(5),
      minWidth: theme.spacing(24.125),
      padding: theme.spacing(1.25, 2),
      borderRadius: theme.spacing(0.5),
      border: `1px solid ${theme.palette.textField.light}`,
      color: theme.palette.labraText.primary,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        backgroundColor: theme.palette.common.white,
        borderColor: theme.palette.textField.light,
      },
      marginTop: theme.spacing(2.5),
    },
    validateConnectionButtonLoading: {
      minWidth: theme.spacing(30.5),
    },
    validateConnectionButtonContent: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(1),
    },
    validateConnectionButtonLabel: {
      display: 'inline-block',
      height: theme.spacing(2.5),
      lineHeight: theme.spacing(2.5),
      fontWeight: 500,
      fontSize: theme.spacing(1.75),
      letterSpacing: '0.1px',
      fontFamily: theme.typography.fontFamily,
      whiteSpace: 'nowrap',
    },
    validateConnectionButtonLoader: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      flexShrink: 0,
      color: theme.palette.labraText.tertiary,
    },
    terraformValidationPanel: {
      height: 'auto',
      marginTop: theme.spacing(1.5),
      borderRadius: theme.spacing(0.5),
      backgroundColor: theme.palette.textBackground.light,
    },
    terraformValidationHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: `${theme.spacing(1.5)} ${theme.spacing(1.5)} 0`,
    },
    terraformValidationStepsList: {
      margin: theme.spacing(1.5),
    },
    terraformValidationStepRow: {
      display: 'flex',
      alignItems: 'center',
      marginTop: theme.spacing(1),
      gap: theme.spacing(1),
      fontWeight: 400,
      fontSize: theme.spacing(1.5),
    },
    terraformStepIconSuccess: {
      color: theme.palette.syncStatus.success,
    },
    terraformStepIconFailed: {
      color: theme.palette.labraV2Errors.main,
    },
    terraformStepIconPending: {
      color: theme.palette.labraText.tertiary,
    },
    terraformValidationErrorBox: {
      marginLeft: theme.spacing(3.5),
      marginTop: theme.spacing(1),
      padding: theme.spacing(2),
      height: 'auto',
      borderRadius: theme.spacing(1),
      border: `1px solid ${theme.palette.labraV2Errors.main}`,
      backgroundColor: theme.palette.backgroundV2.tertiary,
    },
    terraformValidationErrorText: {
      display: 'flex',
      margin: `-5px ${theme.spacing(-0.125)}`,
      fontWeight: 400,
      fontSize: theme.spacing(1.5),
      color: theme.palette.labraV2Errors.main,
      whiteSpace: 'pre-line',
    },
    terraformValidationStepItem: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    terraformValidationRequiredError: {
      fontSize: theme.spacing(1.5),
      fontWeight: 400,
      lineHeight: theme.spacing(2),
      letterSpacing: '0.1px',
      color: theme.palette.labraV2Errors.main,
      fontFamily: theme.typography.fontFamily,
    },
  })
)
